import { Checkbox, Text } from '@shopify/polaris';
import { memo } from 'react';

interface ITruncatedCheckboxProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  maxWidth?: string;
  disabled?: boolean;
}

export const TruncatedCheckbox = memo(
  ({ label, checked, onChange, maxWidth = '200px', disabled = false }: ITruncatedCheckboxProps) => {
    return (
      <div className="flex items-center gap-2">
        <Checkbox label="" labelHidden checked={checked} disabled={disabled} onChange={onChange} />
        <div
          className="cursor-pointer select-none min-w-0 flex-1"
          style={{ maxWidth }}
          onClick={() => (!disabled ? onChange() : undefined)}
        >
          <Text variant="bodyMd" fontWeight="medium" as="span" truncate>
            {label}
          </Text>
        </div>
      </div>
    );
  },
);
